import { combineReducers } from '@reduxjs/toolkit';
import { thunk } from 'redux-thunk';

import { BaseLinksReducer } from './Auth/Links/BaseLinksSlice';
import { AuthApi } from './_Api/Auth';
import { UsersApi } from './_Api/Users';
import { CustomersApi } from './_Api/Customers';
import { ContactsApi } from './_Api/Contacts';
import { SitesApi } from './_Api/Sites';
import { LocationsApi } from './_Api/Locations';
import { PensApi } from './_Api/Pens';
import { TopBoxesApi } from './_Api/TopBoxes';
import { OperatorsApi } from './_Api/Operators';
import { RobotsApi } from './_Api/TopBoxes/Robots';
import SidebarReducer from './Slices/SidebarSlice';
import { RobotsFilterListApi } from './_Api/TopBoxes/Robots/Filters';
import { HoleDetectionApi } from './_Api/HoleDetection';
import { GnssApi } from './_Api/Gnss';
import { DepartmentsApi } from './_Api/Departments';
import { PowerBiApi } from './_Api/PowerBi';

const rootReducer = combineReducers({
  baseLinks: BaseLinksReducer,
  sidebar: SidebarReducer,
  [AuthApi.reducerPath]: AuthApi.reducer,
  [UsersApi.reducerPath]: UsersApi.reducer,
  [CustomersApi.reducerPath]: CustomersApi.reducer,
  [ContactsApi.reducerPath]: ContactsApi.reducer,
  [SitesApi.reducerPath]: SitesApi.reducer,
  [LocationsApi.reducerPath]: LocationsApi.reducer,
  [PensApi.reducerPath]: PensApi.reducer,
  [TopBoxesApi.reducerPath]: TopBoxesApi.reducer,
  [OperatorsApi.reducerPath]: OperatorsApi.reducer,
  [RobotsApi.reducerPath]: RobotsApi.reducer,
  [RobotsFilterListApi.reducerPath]: RobotsFilterListApi.reducer,
  [HoleDetectionApi.reducerPath]: HoleDetectionApi.reducer,
  [GnssApi.reducerPath]: GnssApi.reducer,
  [DepartmentsApi.reducerPath]: DepartmentsApi.reducer,
  [PowerBiApi.reducerPath]: PowerBiApi.reducer,
});

export const middleware = [
  thunk,
  AuthApi.middleware,
  UsersApi.middleware,
  CustomersApi.middleware,
  ContactsApi.middleware,
  SitesApi.middleware,
  LocationsApi.middleware,
  PensApi.middleware,
  TopBoxesApi.middleware,
  OperatorsApi.middleware,
  RobotsApi.middleware,
  RobotsFilterListApi.middleware,
  HoleDetectionApi.middleware,
  GnssApi.middleware,
  DepartmentsApi.middleware,
  PowerBiApi.middleware,
];

export default rootReducer;
